import React from 'react'
import { getVideo } from 'Utils/videoUrls'
import DOMPurify from 'dompurify'
import { Tooltip } from '@mui/material'
import useTooltipEnabled from 'Hooks/useTooltipEnabled'

interface VideoProps {
  videos?: any
}

const Videos = ({ videos }: VideoProps) => {
  const tooltipEnabled = useTooltipEnabled()

  return (
    <>
      {videos.map((video: any) => {
        const accessibilityText = video.title
        return (
          <div
            key={video.id || video.hotspotMediaId}
            tabIndex={0}
            aria-label={accessibilityText}
          >
            <h3>{video.title}</h3>
            <Tooltip
              title={accessibilityText}
              placement='top'
              arrow
              disableHoverListener={!tooltipEnabled}
              disableFocusListener={!tooltipEnabled}
              disableTouchListener={!tooltipEnabled}
            >
              <div style={{ display: 'flex' }}>{getVideo(video)}</div>
            </Tooltip>
            <p
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(video.description, {
                  ADD_ATTR: ['target'],
                }),
              }}
            />
          </div>
        )
      })}
    </>
  )
}

export default Videos
